"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCfb = loadCfb;
const cfb_interop_1 = require("../../cfb-interop");
async function loadCfb(fileContents) {
    const arrayBuffer = await fileContents.arrayBuffer();
    const u8 = new Uint8Array(arrayBuffer);
    return cfb_interop_1.CFB.read(u8, { type: 'array' });
}
//# sourceMappingURL=cfbUtil.js.map